import {RED, YELLOW, GREEN} from './colours';
import {
  Shape,
  Text,
  Bitmap,
  Container
} from "@createjs/easeljs";

const statuses = {
  partial: {
    heading: "PARTIAL LAUNCH",
    message: "Congratulations, but your rocket launch did not go high enough\n to deploy the satellite. Try again to get higher!",
    color: YELLOW,
    border: 'feedbackBorderYellow'
  },
  success: {
    heading: "SUCCESSFUL DEPLOYMENT",
    message: "Congratulations, your rocket reached space and successfully deployed its payload.",
    color: GREEN,
    border: 'feedbackBorderGreen'
  },
  fail: {
    heading: "FAILED LAUNCH",
    message: "Oh no! The rocket wasn't powerful enough to get off the ground. Try again.",
    color: RED,
    border: 'feedbackBorderRed'
  },
  exploded: {
    heading: "CATASTROPHIC FAILURE",
    message: "Oh no! The unmanned rocket has exploded due to high stress.\n Try increasing mass or reducing thrust.",
    color: RED,
    border: 'feedbackBorderRed'
  }
};

const styles = {
  results: "14px Poppins",
  title: "bold 38px Poppins",
  message: "18px Poppins"
};
function formatNumber(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function createResultModal({ status, stats, rocket, imageQueue}) {
  var modal = new Container();
  var border = new Bitmap(imageQueue.getResult(statuses[status].border));
  border.scaleX = 1.32;
  border.scaleY = 1.32;
  modal.addChild(border);
  createHeading(modal, status);
  createInfoText(modal, status, stats, rocket);
  modal.alpha = 0;
  return modal;
}

function createHeading(container, status) {
  var heading = new Text(statuses[status].heading, styles.title, statuses[status].color);
  heading.x = 360;
  heading.y = 85;
  heading.textAlign = 'center';
  heading.textBaseline = 'middle';
  container.addChild(heading);
}

function createInfoText(container, status, stats, rocket) {
  const color = statuses[status].color;

  var message = new Text(
      statuses[status].message,
      "18px Arial", color);
  message.x = 360;
  message.y = 115;
  message.lineWidth = 600;
    message.lineHeight = 25;
  message.textAlign = 'center';
  container.addChild(message);

  var statsContainer = new Container();
  statsContainer.y = 180;

  var heightReached = stats.maxHeight;
  var heightReachedFormat = formatNumber( Math.round( Number( heightReached ) ) );
  var heightReached = new Text(`Height reached: ${ heightReachedFormat } km`, styles.results,
      color);
  heightReached.x = 80;
  heightReached.y = 0;
  statsContainer.addChild(heightReached);

  var maxSpeed = stats.maxSpeed;
  var maxSpeedFormat = formatNumber( Number( maxSpeed ) );
  var maxSpeed = new Text(`Max speed: ${ maxSpeedFormat } m/s`, styles.results, color);
  maxSpeed.x = 80;
  maxSpeed.y = 30;
  statsContainer.addChild(maxSpeed);

  var timeNumber = stats.timeToMaxHeight;
  var timeNumberFormat = formatNumber( Number( timeNumber ) );
  var time = new Text(`Time to max height: ${ timeNumberFormat } seconds`,
    styles.results, color);
  time.x = 80;
  time.y = 60;
  statsContainer.addChild(time);

  var prevHeightNumber = stats.prevHeight;
  var preveheightFormat = formatNumber( Math.round( Number( prevHeightNumber ) ) );
  if (  isNaN(preveheightFormat) != false ) {
    var prevHeight = new Text(`Previous height reached: n/a`, styles.results,
      color);
  } else {
    var prevHeight = new Text(`Previous height reached: ${ prevHeightNumber } km`, styles.results,
      color);
  }
  prevHeight.x = 80;
  prevHeight.y = 90;
  statsContainer.addChild(prevHeight);

  var rocketMassNumber = rocket.mass;
  var rocketMassFormat = formatNumber( Number( rocketMassNumber ) );
  var rocketMass = new Text(`Rocket starting mass: ${ rocketMassFormat } kg`, styles.results,
      color);
  rocketMass.x = 400;
  rocketMass.y = 0;
  statsContainer.addChild(rocketMass);

  var thrustNumber = rocket.thrust;
  var thrustFormat = formatNumber( Number( thrustNumber ) );
  var thrust = new Text(`Rocket thrust: ${ thrustFormat } N`, styles.results,
      color);
  thrust.x = 400;
  thrust.y = 30;
  statsContainer.addChild(thrust);

  var thrustTimeNumber = rocket.thrust_time;
  var thrustTimeFormat = formatNumber( Number( thrustTimeNumber ) );
  var thrustTime = new Text(`Rocket thrust time: ${ thrustTimeFormat } seconds`,
      styles.results, color);
  thrustTime.x = 400;
  thrustTime.y = 60;
  statsContainer.addChild(thrustTime);

  var drag = new Text(`Drag: ${rocket.drag ? 'ON' : 'OFF'}`, styles.results, color);
  drag.x = 400;
  drag.y = 90;
  statsContainer.addChild(drag);

  var massChange = new Text(`Mass change: ${rocket.mass_change ? 'ON' : 'OFF'}`, styles.results, color);
  massChange.x = 400;
  massChange.y = 120;
  statsContainer.addChild(massChange);

  container.addChild(statsContainer);
}
